import React from 'react'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import Typography from 'components/typography'
import _ from 'lodash'
// import { useWindowSize } from 'react-use'
import { ReactComponent as EmptyStarIcon } from 'images/EmptyStar.svg'
import { ReactComponent as FullStarIcon } from 'images/FullStar.svg'
import { Button } from 'components'

const Container = styled.div`
  // width: 100%;
`
const StarRow = styled.div`
  // width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

// const size = 30
const Tag = styled((props) => <Button {...props} />)`
  border: 1px solid #fff;
  color: #253e87;
  border-radius: 10px;
  height: 30px;
  font-size: 12px;
  padding: 6px 8px;
  background-color: #ebf4f9;
  cursor: default;
  width: 84px;
`
const Rating = ({ rating, disabledTagProps }) => {
  // const { width } = useWindowSize()

  // if (!rating || rating <= 0) {
  //   return null
  // }
  return (
    <ErrorBoundary>
      <Container>
        <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center' }}>
          {/* <Typography
            // id="market.detail.rating"
            styled={{ color: '#253E87', fontSize: '12px' }}
            lineHeight={'20px'}
            fontWeight={600}
            // margin={width <= 425 ? '0 0 10px 0' : '0 0 15px 0'}
          >
            {rating.toString()}
          </Typography> */}
          <StarRow>
            {_.times(5, (index) => {
              if (index < rating) {
                return (
                  <FullStarIcon
                    width={!disabledTagProps ? 10 : 20}
                    height={!disabledTagProps ? 10 : 20}
                  />
                )
              }
              return (
                <EmptyStarIcon
                  width={!disabledTagProps ? 10 : 20}
                  height={!disabledTagProps ? 10 : 20}
                />
              )
            })}
          </StarRow>
          <Typography
            // id="market.detail.rating"
            styled={{ color: '#253E87', fontSize: '12px' }}
            lineHeight={'20px'}
            fontWeight={600}
            // margin={width <= 425 ? '0 0 10px 0' : '0 0 15px 0'}
          >
            {rating === undefined ? 0 : rating.toString()}
          </Typography>
          {!disabledTagProps && (
            <div>
              <Tag nowrap fontSize={'12px'} fontWeight={400} lineHeight="20px">
                <Typography
                  // id="market.detail.rating"
                  styled={{ color: '#253E87', fontSize: '12px' }}
                  lineHeight={'20px'}
                  fontWeight={400}
                  color="primary1"
                  // margin={width <= 425 ? '0 0 10px 0' : '0 0 15px 0'}
                >
                  {'Marketing'}
                </Typography>
              </Tag>
            </div>
          )}
        </div>
      </Container>
    </ErrorBoundary>
  )
}

export default Rating
